// extracted by mini-css-extract-plugin
export default {"container":"placeholder_container__QaF1V","top":"placeholder_top__PzBt3","bottom":"placeholder_bottom__9b3mw","text":"placeholder_text__nUdOp"};